import { useState, useEffect, type ChangeEvent } from 'react';
import { Volume2, VolumeX } from 'lucide-react';
import { audioManager } from '@/utils/audioManager';
import { useSafeNavigate } from '@/hooks/useSafeNavigate';

const Settings = () => {
  const navigate = useSafeNavigate();
  const [sfxVolume, setSfxVolume] = useState(1);

  // Load current volume settings on mount
  useEffect(() => {
    const settings = audioManager.getVolumeSettings();
    setSfxVolume(settings.master);
  }, []);

  const handleVolumeChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newVolume = parseFloat(e.target.value);
    setSfxVolume(newVolume);
    audioManager.setMasterVolume(newVolume);
  };

  const isMuted = sfxVolume === 0;

  return (
    <div style={{
      padding: '2rem',
      height: '100vh',
      backgroundColor: '#1a1a1a'
    }}>
      <h1>Game Settings</h1>

      <div style={{
        backgroundColor: '#333',
        padding: '2rem',
        borderRadius: '12px',
        marginTop: '2rem',
        maxWidth: '600px'
      }}>
        <h3>Audio Settings</h3>
        <div style={{ margin: '1rem 0' }}>
          <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
            {isMuted ? <VolumeX size={20} style={{ display: 'inline', marginRight: '0.5rem' }} /> : <Volume2 size={20} style={{ display: 'inline', marginRight: '0.5rem' }} />}
            Sound Effects Volume
          </label>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <input
              type="range"
              min="0"
              max="1"
              step="0.01"
              value={sfxVolume}
              onChange={handleVolumeChange}
              style={{
                width: '100%',
                accentColor: '#4CAF50'
              }}
            />
            <span style={{ minWidth: '50px', textAlign: 'right' }}>
              {isMuted ? 'Muted' : `${Math.round(sfxVolume * 100)}%`}
            </span>
          </div>
        </div>
        <div style={{ margin: '1rem 0' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '1rem', opacity: 0.5 }}>
            <input type="checkbox" defaultChecked disabled />
            Background Music (Coming Soon)
          </label>
        </div>

        <h3 style={{ marginTop: '2rem' }}>Game Settings</h3>
        <div style={{ margin: '1rem 0' }}>
          <label style={{ display: 'block', marginBottom: '0.5rem' }}>
            Running Time (seconds)
          </label>
          <input
            type="range"
            min="5"
            max="15"
            defaultValue="8"
            style={{ width: '100%' }}
          />
          <span>8 seconds</span>
        </div>

        <div style={{ margin: '1rem 0' }}>
          <label style={{ display: 'block', marginBottom: '0.5rem' }}>
            Question Display Time (seconds)
          </label>
          <input
            type="range"
            min="5"
            max="20"
            defaultValue="10"
            style={{ width: '100%' }}
          />
          <span>10 seconds</span>
        </div>
      </div>

      <button
        onClick={() => navigate('/lobby')}
        style={{
          position: 'absolute',
          bottom: '30px',
          left: '30px',
          padding: '1rem 2rem',
          fontSize: '1.1rem',
          backgroundColor: '#757575',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer'
        }}
      >
        Back to Lobby
      </button>
    </div>
  );
};

export default Settings;
